import type { PickDeep } from 'type-fest'
import type { UkModuleOptions } from '../../module'
import type { PublicUkOptionPath } from '../../publicOptions'
import { useRuntimeConfig } from '#imports'

export const useUkConfig = (): PickDeep<UkModuleOptions, PublicUkOptionPath> => {
    const config = useRuntimeConfig()

    return config.public.uk as PickDeep<UkModuleOptions, PublicUkOptionPath>
}
